import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowUp: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20 13.9454C20 14.1454 19.9001 14.4454 19.8 14.6454C19.4001 15.0454 18.8 15.1454 18.4 14.7454L12.0001 9.24536L5.70005 14.7454C5.30005 15.1454 4.60005 15.0454 4.30005 14.6454C3.90005 14.2454 4.00005 13.5454 4.40005 13.2454L11.4001 7.24536C11.8001 6.94536 12.3 6.94536 12.7 7.24536L19.7 13.2454C19.9 13.3454 20 13.6454 20 13.9454Z',
    })
  )
}
